import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["type", "disabled", "title", "aria-label"]
const _hoisted_2 = {
  key: 1,
  class: "inline-flex items-center justify-center"
}

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    title: {},
    ariaLabel: {},
    type: {},
    variant: {},
    size: {},
    shape: {},
    disabled: { type: Boolean },
    loading: { type: Boolean },
    ghost: { type: Boolean },
    bordered: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const onClick = (e: MouseEvent) => {
  if (props.disabled || props.loading) return
  emit('click', e)
}

const isGhost = computed(() => {
  // Default to ghost mode unless bordered is explicitly true
  return !props.bordered
})

const sizeClass = computed(() => {
  const shape = props.shape ?? 'icon'

  // Ghost mode - padding-based sizing like EmployeeRow.vue (default behavior)
  if (isGhost.value) {
    switch (props.size) {
      case 'sm':
        return 'icon-action-btn--ghost-sm'
      case 'lg':
        return 'icon-action-btn--ghost-lg'
      default:
        return 'icon-action-btn--ghost-md'
    }
  }

  if (shape === 'pill') {
    switch (props.size) {
      case 'sm':
        return 'icon-action-btn--pill-sm'
      case 'lg':
        return 'icon-action-btn--pill-lg'
      default:
        return 'icon-action-btn--pill-md'
    }
  }

  // bordered icon-only (old behavior)
  switch (props.size) {
    case 'sm':
      return 'icon-action-btn--sm'
    case 'lg':
      return 'icon-action-btn--lg'
    default:
      return 'icon-action-btn--md'
  }
})

const spinnerSizeClass = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'w-4 h-4'
    case 'lg':
      return 'w-6 h-6'
    default:
      return 'w-5 h-5'
  }
})

const variantClass = computed(() => {
  // If ghost mode (default), use ghost variant classes
  if (isGhost.value) {
    switch (props.variant) {
      case 'primary':
        return 'icon-action-btn--ghost-primary'
      case 'danger':
        return 'icon-action-btn--ghost-danger'
      case 'success':
        return 'icon-action-btn--ghost-success'
      case 'warning':
        return 'icon-action-btn--ghost-warning'
      default:
        return 'icon-action-btn--ghost-neutral'
    }
  }

  // Bordered mode (old behavior)
  switch (props.variant) {
    case 'primary':
      return 'icon-action-btn--primary'
    case 'danger':
      return 'icon-action-btn--danger'
    case 'success':
      return 'icon-action-btn--success'
    case 'warning':
      return 'icon-action-btn--warning'
    default:
      return 'icon-action-btn--neutral'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: __props.type,
    disabled: __props.disabled || __props.loading,
    title: __props.title,
    "aria-label": __props.ariaLabel || __props.title || 'Action',
    class: _normalizeClass(["icon-action-btn", [
      sizeClass.value,
      variantClass.value,
      (__props.disabled || __props.loading) ? 'icon-action-btn--disabled' : ''
    ]]),
    onClick: onClick
  }, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          class: _normalizeClass(["animate-spin", spinnerSizeClass.value]),
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          "aria-hidden": "true"
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }, null, -1),
          _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          }, null, -1)
        ]))], 2))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
  ], 10, _hoisted_1))
}
}

})